import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-muxianNormal",
  "use": "icon-muxianNormal-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-muxianNormal\"><defs><clipPath id=\"icon-muxianNormal_a\"><path data-name=\"矩形 328\" d=\"M0 0h10v10H0z\" /></clipPath></defs><g data-name=\"蒙版组 40\" clip-path=\"url(#icon-muxianNormal_a)\"><path d=\"M5 0a5 5 0 1 1-5 5 5 5 0 0 1 5-5zm2.3 3.232a.5.5 0 0 0-.707 0L4.116 5.707 3.409 5a.5.5 0 0 0-.707.707l1.061 1.061a.5.5 0 0 0 .707 0L7.3 3.939a.5.5 0 0 0 0-.707z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol